/** An Element Select Event */
export default class Select extends CustomEvent {
    constructor(caller) {
        super('select', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
